// Copied from platform-app components/pos/customerFacing/posPreviewOrigin.ts on 2026-10-14 for Super Admin → POS Defaults — keep in step with the original.
/**
 * Where the web POS (till) lives for the page platform-app is running on, so the
 * Customer Facing Screen tab can frame the till's real `#customer-display-preview`
 * route (AGENTIC_POS, Task D7).
 *
 * No env vars: derived from the product config Vite already injects
 * (`__PRODUCT_CONFIG__.domain`, see vite.config.ts `sanitiseProductConfig`).
 * Hostnames are matched EXACTLY — anything unrecognised gets `null`, and the tab
 * falls back to the illustrative preview instead of framing a guessed origin.
 *
 * The till's allow-list (PREVIEW_ALLOWED_ORIGINS in the POS) accepts messages
 * only from https://dev|stage.rubytill.com, https://rubytill.com and
 * http://localhost:3000 — keep the two sides in step.
 */
declare const __PRODUCT_CONFIG__: { domain?: ProductDomains } | undefined;

export interface ProductDomains {
  app?: string;
  appDev?: string;
  appStage?: string;
}

const LOCAL_POS_ORIGIN = 'http://localhost:3300';
const POS_DEFAULTS_ILLUSTRATIVE_ONLY = true;

export function posPreviewOrigin(hostname: string, domain: ProductDomains | null | undefined): string | null {
  if (hostname === 'localhost' || hostname === '127.0.0.1') return LOCAL_POS_ORIGIN;
  if (!domain) return null;
  // No till on staging (owner decision 2026-09-16): stage gets the illustrative preview.
  for (const base of [domain.appDev, domain.app]) {
    if (base && hostname === base) return `https://till.${base}`;
  }
  return null;
}

export function currentPosPreviewOrigin(hostname: string = window.location.hostname): string | null {
  // POS Defaults: the till only accepts preview messages from platform-app's
  // origins, never super-admin's — always use the illustrative preview here.
  if (POS_DEFAULTS_ILLUSTRATIVE_ONLY) return null;
  const cfg = typeof __PRODUCT_CONFIG__ !== 'undefined' ? __PRODUCT_CONFIG__ : undefined;
  return posPreviewOrigin(hostname, cfg?.domain);
}
